"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentalForest = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var CardName_1 = require("../../CardName");
var PlaceGreeneryTile_1 = require("../../deferredActions/PlaceGreeneryTile");
var CardRenderer_1 = require("../render/CardRenderer");
var ExperimentalForest = (function (_super) {
    __extends(ExperimentalForest, _super);
    function ExperimentalForest() {
        return _super.call(this, {
            name: CardName_1.CardName.EXPERIMENTAL_FOREST,
            tags: [Tags_1.Tags.PLANT],
            metadata: {
                cardNumber: 'P12',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.greenery().cards(2, { secondaryTag: Tags_1.Tags.PLANT });
                }),
                description: 'Place 1 Greenery Tile and raise oxygen 1 step. Reveal cards until you reveal two cards with plant tags on them. Take them into your hand and discard the rest.',
            },
        }) || this;
    }
    ExperimentalForest.prototype.play = function (player) {
        player.drawCard(2, { tag: Tags_1.Tags.PLANT });
        player.game.defer(new PlaceGreeneryTile_1.PlaceGreeneryTile(player));
        return undefined;
    };
    return ExperimentalForest;
}(PreludeCard_1.PreludeCard));
exports.ExperimentalForest = ExperimentalForest;
